import { useEffect, useState } from 'react';
import { supabase } from '../services/supabase';

export const useSubscription = () => {
  const [subscription, setSubscription] = useState(null);
  const [loading, setLoading] = useState(true);
  const [tier, setTier] = useState('free');

  useEffect(() => {
    const fetchSubscription = async () => {
      try {
        const { data: { user } } = await supabase.auth.getUser();
        if (!user) {
          setLoading(false);
          return;
        }

        const { data, error } = await supabase
          .from('user_settings')
          .select('subscription')
          .eq('user_id', user.id)
          .single();

        if (error || !data?.subscription) {
          // No subscription found - default to free tier
          console.log('No subscription found, defaulting to free tier');
          setTier('free');
          setSubscription(null);
          setLoading(false);
          return;
        }

        // Subscription exists, check if it's still active
        if (data.subscription?.ends_at) {
          const endDate = new Date(data.subscription.ends_at);
          if (endDate > new Date()) {
            // Subscription is active
            setSubscription(data.subscription);
            setTier(data.subscription.tier || 'free');
          } else {
            // Subscription expired - default to free tier
            setTier('free');
            setSubscription(null);
          }
        } else {
          // No end date - assume active
          setSubscription(data.subscription);
          setTier(data.subscription.tier || 'free');
        }
      } catch (error) {
        console.error('Error fetching subscription:', error);
        setTier('free');
        setSubscription(null);
      } finally {
        setLoading(false);
      }
    };

    fetchSubscription();
  }, []);

  const isPremium = tier === 'premium' || tier === 'pro';
  const isPro = tier === 'pro';

  return { subscription, loading, tier, isPremium, isPro };
};
